import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../../styles';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      listStyleType: 'none',
    },
    list: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      listStyleType: 'none',

      '&:hover': {
        '& $value': {
          borderColor: 'var(--x-accent-2-5)',
          color: 'var(--x-accent-2-1)',
          backgroundColor: 'rgba(218, 202, 251, 0.3)',
        },
        '& $icon path': {
          fill: 'var(--x-accent-2-1)',
        },
      },
    },
    type: {
      textTransform: 'uppercase',
      color: 'var(--x-text-color-1)',
      fontSize: '20px',
      fontWeight: 500,
      width: '6ch',
    },
    value: {
      alignItems: 'center',
      backgroundColor: 'var(--x-bg-1)',
      border: '1px solid #CBCBCB',
      borderRadius: 8,
      color: 'var(--x-textf-field-color-1)',
      cursor: 'pointer',
      display: 'flex',
      flex: 1,
      fontSize: '20px',
      fontWeight: 500,
      justifyContent: 'flex-start',
      lineHeight: '1.75rem',
      minHeight: 56,
      minWidth: '10.125rem',
      padding: '15px 16px',

      [mediaQuery(breakpoints.mobile)]: {
        minHeight: 48,
        padding: '10px 16px',
      },
    },
    copyBtn: {
      backgroundColor: 'transparent',
      border: 0,
      cursor: 'pointer',
      marginInlineStart: '1rem',
      width: '1.5rem',
    },
    icon: {
      '& path': {
        fill: 'var(--x-textf-field-color-1)',
      },
    },
  }),
  { name: 'ColorCopy' },
);
